<mat-card>
  <mat-card-content>

    <div id="top">
      <h1><b>Contact Details</b></h1>
      <button mat-fab extended (click)="addContactButtonPressed()" class="warn" id="addContact">ADD CONTACT</button>
    </div>
    <p class="sectionDescription">The contacts listed here will be used as supplementary information. These contacts will not have access to the dashboard.</p>
    
    <div class="content">
      <ag-grid-angular
      style="width: 100%; height: 500px"
        [theme]="theme"
        [rowData]="dataSource$ | async"
        [columnDefs]="colDefs"
        [suppressCellFocus]="true"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        [gridOptions]="gridOptions"
        (cellClicked)="onCellClicked($event)"
      />
    </div>
  </mat-card-content>
</mat-card>
